import { get, patch, post, download } from "../utils/api";

export const orderCreate = (data) => {
  return post("/order", data);
};

export const customerOrderList = (data) => {
  return get("/order", data);
};

function orderPathSegment(orderId) {
  const id = orderId == null ? "" : String(orderId).trim();
  if (!id || id === "undefined" || id === "null") {
    return null;
  }
  return encodeURIComponent(id);
}

export const customerOrderById = (id) => {
  const seg = orderPathSegment(id);
  if (!seg) {
    return Promise.reject({ data: { message: "Order id is missing" } });
  }
  // Path without ":" avoids url() param substitution bugs; id is only in the path.
  return get(`/order/${seg}`, {});
};

export const customerOrderUpdate = (id, data) => {
  const seg = orderPathSegment(id);
  if (!seg) {
    return Promise.reject({ data: { message: "Order id is missing" } });
  }
  return patch(`/order/${seg}`, data ?? {});
};

export const personalShopperList = (data) => {
  return get("/admin/personal-shopper/list", data);
};

export const personalShopperAssign = (data) => {
  return post("/admin/personal-shopper/assign-shopper", data);
};

export const createPaymentOrder = (orderId) => {
  const seg = orderPathSegment(orderId);
  if (!seg) {
    return Promise.reject({ data: { message: "Order id is missing" } });
  }
  return post(`/order/${seg}/payment/create`, {});
};

export const verifyPayment = (orderId, data) => {
  const seg = orderPathSegment(orderId);
  if (!seg) {
    return Promise.reject({ data: { message: "Order id is missing" } });
  }
  return post(`/order/${seg}/payments/verify`, data);
};

export const getPayments = (orderId) => {
  const seg = orderPathSegment(orderId);
  if (!seg) {
    return Promise.reject({ data: { message: "Order id is missing" } });
  }
  return get(`/order/${seg}/payments`, {});
};

export const retryPayment = (orderId) => {
  const seg = orderPathSegment(orderId);
  if (!seg) {
    return Promise.reject({ data: { message: "Order id is missing" } });
  }
  return post(`/order/${seg}/payment/retry`, {});
};

export const logPaymentEvent = (orderId, data) => {
  const seg = orderPathSegment(orderId);
  if (!seg) {
    return Promise.reject({ data: { message: "Order id is missing" } });
  }
  return post(`/order/${seg}/payments/event`, data);
};

export const getPaymentTimeline = (paymentId) => {
  return get(`/payments/${paymentId}/timeline`, {});
};

export const downloadOrderInvoicePdf = (orderId, isAdmin = false) => {
  const seg = orderPathSegment(orderId);
  if (!seg) {
    return Promise.reject({ data: { message: "Order id is missing" } });
  }
  const path = isAdmin ? `/admin/order/${seg}/invoice-pdf` : `/order/${seg}/invoice-pdf`;
  return download(path);
};

export const orderApi = {
  orderCreate,
  customerOrderList,
  customerOrderById,
  customerOrderUpdate,
  personalShopperList,
  personalShopperAssign,
  createPaymentOrder,
  verifyPayment,
  getPayments,
  retryPayment,
  logPaymentEvent,
  getPaymentTimeline,
  downloadOrderInvoicePdf,
};

